import type { StateCreator } from 'zustand';

export interface ProjectSlice {
  isRemoteProject: boolean;
  setIsRemoteProject: (remote: boolean) => void;
  shouldSkipAutoGeneration: boolean;
  setShouldSkipAutoGeneration: (skip: boolean) => void;
  projectCreditsCount: number | null;
  setProjectCreditsCount: (count: number | null) => void;
}

export const projectInitialState = {
  isRemoteProject: false,
  shouldSkipAutoGeneration: false,
  projectCreditsCount: null as number | null,
};

export const createProjectSlice: StateCreator<
  ProjectSlice,
  [],
  [],
  ProjectSlice
> = (set) => ({
  ...projectInitialState,

  setIsRemoteProject: (isRemoteProject) => set({ isRemoteProject }),
  setShouldSkipAutoGeneration: (shouldSkipAutoGeneration) =>
    set({ shouldSkipAutoGeneration }),
  setProjectCreditsCount: (projectCreditsCount) => set({ projectCreditsCount }),
});
